// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".edit-isPaused-btn--rJyNm{margin-left:10;font-size:13px;text-decoration:none}", "",{"version":3,"sources":["webpack://./src/pages/ContractDetails/RightPanel/Billing/PauseBilling/components/custom-toggle-title.module.scss"],"names":[],"mappings":"AAAA,0BACE,cAAA,CACA,cAAA,CACA,oBAAA","sourcesContent":[".edit-isPaused-btn {\n  margin-left: 10;\n  font-size: 13px;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"edit-isPaused-btn": "edit-isPaused-btn--rJyNm"
};
export default ___CSS_LOADER_EXPORT___;
